import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { useDispatch } from "react-redux";
import { setSearchLineIsShown } from "../../../stateManagement/reducers";
import { getItemWebStorage } from "src/features/webStorageSaver";

const goToRoadSearchButtonIconSrc = require("../../../assets/images/icons/search-icon.svg.png");

export default function SelectedPathDisplay() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentConfig = getItemWebStorage("currentConfig");
    const isRoadsListPageAvailable = currentConfig?.menuShow?.road;

    const { roadName, pathName } = useAppSelector((state) => state.pathsInfo.selectedPath) ?? {};

    function goToRoadsList() {
        navigate('/app/roads/list')
    }

    function goToRoadsListSearch() {
        navigate('/app/roads/list')
        dispatch(setSearchLineIsShown(true))
    }

    return (
        <div className="selected-path-display-div">
            {isRoadsListPageAvailable &&
                <>
                    <div className="go-to-road-search-button" onClick={goToRoadsListSearch}>
                        <img src={goToRoadSearchButtonIconSrc} alt="road-search-button" />
                    </div>
                    <div className="path-description" onClick={goToRoadsList}>
                        <span>
                            {roadName ?? "Дорога не выбрана"}
                        </span>
                        <span>
                            {pathName ?? "Направление не выбрано"}
                        </span>
                    </div>
                </>
            }
        </div>
    );
}
